export const equipmentListDefaultQuery = {
    expandTemplate: true,
    sortBy: 'equipmentId',
    isDesc: false
}
